module.exports = __webpack_public_path__ + "media/DJ_MAARTEN_WEDERHOOR.mp4";